import $ from 'jquery'

/*
    HowTo

    ~ Import ~
    import infiniteScroll from "infinite-scroll";

    ~ Data-JSON ~
    An Object with all the needed Strings for the Infinite-Scroll (shown JSON is an example)


        (Var. Name)                         (Example)                               (Description)
    const set = {
        dataKeeper:                         "#overview-data-keeper-js"              -> (Class/ID) Container which only contains: data-page, data-nexrpage, data-realpage, data-renderUrl(defined by renderIdentify (!called with data(renderIdentify)!))
        overviewContainer:                  "#overview-container"                   -> (Class/ID) Container which contains the infinite-Leaded Items
        overviewInfiniteScrollingMarker:    "#overview-infinite-scrolling-marker"   -> (Class/ID) Container with loading-animation (gives/removes class "active")
        cookieName:                         "overview"                              -> (Name) name of the cookie, used to scroll to the article if the user comes back to the page after visiting a details-page *1
        btn:                                ".btn"                                  -> (Class) Container with button for each article, used to save the chosen article for the cookie *1
        backToTop:                          "#infinite-scrolling-back-to-top"       -> (Class/ID) Container for the 'back-to-top'-function
        selector:                           ".two-column-wrapper"                   -> (Class)Container of each Shown Element, contains data-handle with the canonicalHandleUUID for each Document Loaded
        renderIdentify:                     "overview-render-url"                   -> (Name) name of the data-(renderIdentify), containing the renderingUrl for the Module (see: set.dataKeeper) *1
        fakeScrolling:                      true/false                              -> (Boolean) if true, ajax-call will be skipped and the script will imitate the infinite-scrolling (optional, unnecessary to set if not intended)
        waiting:                            3000                                    -> (Number) time to wait until the new elements are 'loaded' *2
        loadingContainer:                   ".infinite-scrolling-animation"         -> (Class/ID) Container for loading-animation (has to be separated for fakeScrolling) *2
        loadedItems                         10                                      -> (Number) Number of Items to load each event *2
        ignoreBackToTop                     true                                    -> (boolean) disables the back-to-top-button, 'backToTop' is no longer required than (fakeScrolling only) (optional)
    };


    *1 = not necessary if fakeScrolling is selected
    *2 = necessary if fakeScrolling is selected

    NOTE:
    Modules with a fake-Scrolling have to be placed right in front of the footer (so, they have to be the last item).
    otherwise the back-to-top-button will not work correctly.

    (Copy-me Version normal)
    const set = {
        dataKeeper: "Class_ID",
        overviewContainer: "Class_ID",
        overviewInfiniteScrollingMarker: "Class_ID",
        cookieName: "Name",
        btn: "Class",
        backToTop: "Class_ID",
        selector: "Class",
        renderIdentify: "Name"
    };

    (Copy-me Version fake)
    const dataSet = {
        dataKeeper: "Class_ID",
        overviewContainer: "Class_ID",
        overviewInfiniteScrollingMarker: "Class_ID",
        backToTop: "Class_ID",
        selector: "Class_ID",
        fakeScrolling: true,
        waiting: number,
        loadingContainer: "Class_ID",
        loadedItems: number
    };


    ~ Initialize ~
    function init() {
        infiniteScroll.init(set);
    }
 */

let dataKeeper,
  overviewContainer,
  overviewInfiniteScrollingMarker,
  cookieName,
  btn,
  backToTop,
  selector,
  $dataKeeper,
  $overviewContainer,
  componentRenderUrl,
  page,
  nextPage,
  realPage,
  infiniteScrollingScene,
  backToTopScene,
  fakeScrolling = false,
  waiting,
  loadingContainer,
  loadedItems,
  rendering = false,
  initiated = false,
  ignoreBackToTop = false,
  backToTopStatus = false,
  scrollMagicController = null

async function init (dataSet) {
  const ScrollMagicLib = await import(/* webpackChunkName: "scrollmagic" */ 'scrollmagic/scrollmagic/uncompressed/ScrollMagic')
  window.ScrollMagic = ScrollMagicLib.default
  await import(/* webpackChunkName: "scrollmagic-debug-add-indictors" */ 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators')

  const CookieLib = await import(/* webpackChunkName: "js-cookie" */ 'js-cookie')
  window.Cookies = CookieLib.default

  await import(/* webpackChunkName: "jquery-lazy" */ 'jquery-lazy')
  scrollMagicController = new ScrollMagic.Controller()
  construct(dataSet)

  if (!fakeScrolling) {
    Cookies.remove(cookieName)
    addEmptyCookie()
    if (!fakeScrolling) {
      $overviewContainer.on('click', btn, function (e) {
        onOpenArticle()
        if ($(this).attr('data-href') != undefined) {
          if ($(this).attr('data-target') === undefined || $(this).attr('data-target') !== 'blank') {
            window.location = $(this).attr('data-href')
          } else {
            e.preventDefault()
            window.open($(this).attr('data-href'), 'blank')
          }
        }
      })
    }
  } else {
    // imitateReload();
  }
  $('footer .back-to-top-container').hide()
  if (nextPage === undefined || nextPage === 0) {
    if (!ignoreBackToTop > 0 && $(backToTop).offset().top > $(overviewContainer).offset().top) {
      backToTopStatus = true
      $(backToTop).css('opacity', 1)
    }
  }

  initInfiniteScrolling()
  if (!ignoreBackToTop) {
    backToTopInfinteScrolling()
  }
  scrollToHandle()

  $(window).on('scroll', function () {
    if ($(document).scrollTop() > 0 && $(backToTop).offset().top > $(overviewContainer).offset().top) {
      if (backToTopStatus) {
        $('#infinite-scrolling-back-to-top').css('opacity', 1)
      }
    } else {
      if (backToTopStatus) {
        $('#infinite-scrolling-back-to-top').css('opacity', 0)
      }
    }

  })
}

function construct (dataSet) {
  dataKeeper = dataSet.dataKeeper
  overviewContainer = dataSet.overviewContainer
  overviewInfiniteScrollingMarker = dataSet.overviewInfiniteScrollingMarker
  selector = dataSet.selector

  $dataKeeper = $(dataKeeper)
  $overviewContainer = $(overviewContainer)

  if (!dataSet.hasOwnProperty('fakeScrolling') && !dataSet.fakeScrolling) {
    cookieName = $dataKeeper.data('cookie-name')
    if (!cookieName) {
      cookieName = dataSet.cookieName
    }

    btn = dataSet.btn
    realPage = $dataKeeper.data('realpage')
    componentRenderUrl = $dataKeeper.data(dataSet.renderIdentify)
    backToTop = dataSet.backToTop
    page = getPage($dataKeeper)
    nextPage = getNextPage($dataKeeper)
  } else {
    if (dataSet.hasOwnProperty('ignoreBackToTop')) {
      ignoreBackToTop = dataSet.ignoreBackToTop
      if (!ignoreBackToTop) {
        backToTop = dataSet.backToTop
      }
    } else {
      backToTop = dataSet.backToTop
    }
    fakeScrolling = true
    waiting = dataSet.waiting
    loadingContainer = dataSet.loadingContainer
    loadedItems = dataSet.loadedItems
    if ($(selector + '.d-none').length > 0) {
      nextPage = 1
    }
  }
}

function initInfiniteScrolling () {
  if (fakeScrolling) {
    infiniteScrollingScene = new ScrollMagic.Scene({
      triggerElement: $(selector + '.d-none')[0],
      triggerHook: 'onEnter',
    })
      .addTo(scrollMagicController)
      .on('enter', function () {
        if (nextPage === undefined || nextPage === 0) {
          InfiniteScrollingMarkerHandler('stop')
        } else {
          getArticles()
        }
      })
  } else {
    infiniteScrollingScene = new ScrollMagic.Scene({
      triggerElement: overviewInfiniteScrollingMarker,
      triggerHook: 'onEnter',
    })
      .addTo(scrollMagicController)
      .on('enter', function () {
        if (nextPage === undefined || nextPage === 0) {
          InfiniteScrollingMarkerHandler('stop')
        } else {
          InfiniteScrollingMarkerHandler('start')
          if (nextPage != 1) {
            setTimeout(function () {
              getArticles()
            }, 500)
          }
        }
      })
  }
}

function InfiniteScrollingMarkerHandler (command) {
  if (fakeScrolling) {
    if (command === 'start') {
      backToTopStatus = true
      $(loadingContainer).addClass('active')
    } else if (command === 'stop') {
      $(loadingContainer).removeClass('active')
    }
  } else {
    if (command === 'start') {
      backToTopStatus = true
      $(overviewInfiniteScrollingMarker).find('.infinite-scrolling-animation').addClass('active')
    } else if (command === 'stop') {
      $(overviewInfiniteScrollingMarker).find('.infinite-scrolling-animation').removeClass('active')
    }
  }
}

function getArticles () {
  if (fakeScrolling) {
    setTimeout(function () {
      imitateReload()
      $(document).trigger('infiniteScrolling')
      infiniteScrollingScene.update()
      checkInfiniteScrollingMarker()
    }, 100)
  } else {
    let requestData = {
      page: nextPage,
      query: query,
      filters: filterArray
    }

    $.ajax({
      url: componentRenderUrl,
      data: requestData,
      dataType: 'html',
      success: function (data) {
        let $data = $(data),
          container = $data.find(overviewContainer),
          loadedDataKeeper = $data.find(dataKeeper),
          dataPage = loadedDataKeeper.data('page'),
          dataNextPage = loadedDataKeeper.data('nextpage'),
          sets = container.find(selector)

        $dataKeeper.data('page', dataPage)
        $dataKeeper.data('nextpage', dataNextPage)

        nextPage = dataNextPage

        sets.each(function () {
          $overviewContainer.append($(this))
        })

        $overviewContainer.promise().done(function () {
          if (sets.length) {
            page = requestData.page
            realPage = requestData.page
          }
          if (nextPage === undefined || nextPage === 0) {
            setTimeout(function () {
              $(backToTop).css('position', 'relative')
              $(document).trigger('infiniteScrolling')
            }, 100)
          } else {
            setTimeout(function () {
              $(document).trigger('infiniteScrolling')
              infiniteScrollingScene.update()
              checkInfiniteScrollingMarker()
            }, 100)
          }
        })
        InfiniteScrollingMarkerHandler('stop')
        $(backToTop).css('opacity', 1)
        checkResults()
      },
      error: function (error) {
        console.debug('%c' + error, 'color:#900')
      }
    })
  }
}

function imitateReload () {
  if (!rendering) {
    rendering = true
    let items = $(selector + '.d-none')
    if (items.length > 0) {
      if (initiated) {
        let adaptiveWait = waiting / loadedItems * (items.length >= loadedItems ? loadedItems : items.length)
        InfiniteScrollingMarkerHandler('start')
        window.setTimeout(() => {
          nextPage = 1
          items.slice(0, loadedItems).each(function () {
            $(this).removeClass('d-none')
          })
          if (items.length > 0) {
            infiniteScrollingScene.triggerElement($(selector + ':not(.d-none)')[$(selector + ':not(.d-none)').length - 1])
            infiniteScrollingScene.update()
          }
          InfiniteScrollingMarkerHandler('stop')
          rendering = false
          if (!ignoreBackToTop) {
            $(backToTop).css('opacity', 1)
          }
          backToTopScene.update()
        }, adaptiveWait)
      } else {
        nextPage = 1
        items.slice(0, loadedItems).each(function () {
          $(this).removeClass('d-none')
        })
        if (items.length > 0) {
          infiniteScrollingScene.triggerElement($(selector + ':not(.d-none)')[$(selector + ':not(.d-none)').length - 1])
          infiniteScrollingScene.update()
        }
        rendering = false
        initiated = true
      }
    } else {
      nextPage = 0
      InfiniteScrollingMarkerHandler('stop')
    }
  }
}

function getPage ($el) {
  if ($el && $el.data('page')) {
    return $el.data('page')
  }
}

function getNextPage ($el) {
  if ($el && $el.data('nextpage')) {
    return $el.data('nextpage')
  }
}

function onOpenArticle () {
  saveHandleInViewport()
  saveStateAsCookie()
}

function saveHandleInViewport () {
  const $els = $(selector)
  const $firstFully = $els.filter((i, el) => isInViewport($(el))).first()
  const $first = $els.filter((i, el) => isInViewport($(el), false)).first()
  const handle = $firstFully && $firstFully.data('handle') || $first && $first.data('handle')

  if (handle) {
    localStorage.setItem('handle', handle)
  } else {
    localStorage.removeItem('handle')
  }
}

function isInViewport ($el, fully = true) {
  let elementTop = $el.offset().top,
    elementBottom = elementTop + $el.outerHeight(),
    viewportTop = $(window).scrollTop(),
    viewportBottom = viewportTop + $(window).height()

  if (fully) {
    return elementTop >= viewportTop && elementBottom <= viewportBottom
  }

  return elementTop < viewportBottom || elementBottom > viewportTop
}

function saveStateAsCookie () {
  Cookies.set(cookieName, JSON.stringify({
    page,
    realPage
  }), { expires: 0.5, sameSite: 'lax' })
}

function addEmptyCookie () {
  Cookies.set(cookieName, 'null', { expires: 0.5, sameSite: 'lax' })
}

function backToTopInfinteScrolling () {
  backToTopScene = new ScrollMagic.Scene({
    triggerElement: $('footer').get(0),
    triggerHook: 'onEnter',
  })
    .addTo(scrollMagicController)
    .on('enter', function () {
      if (nextPage === undefined || nextPage === 0) {
        $(backToTop).css('position', 'relative')
      }
    })
    .on('progress', (e) => {
      if (e.progress === 1) {
        $(backToTop).css('position', 'relative')
      } else {
        $(backToTop).css('position', 'fixed')
      }
    })
    .on('start', function (e) {
      if (e.scrollDirection === 'REVERSE' && (nextPage === undefined || nextPage === 0)) {
        $(backToTop).css('position', 'fixed')
      }
    })
}

function scrollToHandle () {
  let handle = localStorage.getItem('handle')

  try {
    if (handle != null && handle !== 'null') {
      $('html, body').animate({ scrollTop: $('.handle-' + handle).offset().top - 300 }, 'slow').promise().done(function () {
        localStorage.removeItem('handle')
      })
    }
  } catch (e) {
    localStorage.removeItem('handle')
  }
}

function checkInfiniteScrollingMarker () {
  const $overviewInfiniteScrollingMarker = $(overviewInfiniteScrollingMarker)

  let viewportTop = $(window).scrollTop(),
    viewportBottom = viewportTop + $(window).height(),
    currentMarkerPosition = $overviewInfiniteScrollingMarker.offset().top + $overviewInfiniteScrollingMarker.outerHeight()

  if (currentMarkerPosition < viewportBottom) {
    getArticles()
  }
}

// for filter
let $filterCategory,
  $filterYear,
  $filterSearch,
  filterArray = [],
  filterObject = {
    'website:category': '',
    'year': '',
  },
  query = ''

function setFilterElements (category, year, search) {
  $filterYear = year
  $filterSearch = search
  $filterCategory = category
}

function setFilter () {
  filterObject['year'] = $filterYear.val()
  window.includeGroupNews ? filterObject['filterNationalInternational'] = $filterCategory.val() : filterObject['website:category'] = $filterCategory.val()
  resetFilter()
  setFilterArray()
}

function resetFilter () {
  filterArray = []
}

function resetPage () {
  nextPage = 1
}

function emptyContent () {
  $overviewContainer.empty()
}

function resetFilterObject () {
  $filterYear.val('').trigger('reset')
  $filterSearch.val('').trigger('reset')
  $filterCategory.val('').trigger('reset')

  setFilter()
}

function setFilterArray () {
  $.each(filterObject, function (key, value) {
    if (value != undefined) {
      if (value === 'all') {
        filterArray.push('' + key + ',')
      } else {
        filterArray.push('' + key + ',' + value + '')
      }
    }
  })
  query = $filterSearch.val()

}

function checkResults () {
  if ($('.have-documents-js [data-handle]').length) {
    $('.have-documents-js').show()
    $('.no-documents-js').hide()
  } else {
    $('.have-documents-js').hide()
    $('.no-documents-js').show()
  }
}

// for filter end

export default {
  init
}

export {
  init,
  emptyContent,
  resetPage,
  setFilter,
  setFilterArray,
  resetFilterObject,
  setFilterElements,
  initInfiniteScrolling,
  getArticles
}
